import clsx from 'clsx'
import React from 'react'
import { MembershipSwitcherDropdown } from '@components/ui/MembershipSwitcherDropdown'
import type { ContractDetails } from '@shared/types/membership'
import './MkAccountMenuHeader.scss'
import { useSiteContext } from '@contexts/MkSiteContext'

export interface MkAccountMenuHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string
  subtitle: string
  /** Label for the expandable "owner ID" section when multiple memberships (e.g. "SELECT OWNER ID") */
  selectOwnerIdLabel: string
  contractDetails?: ContractDetails[]
}

/**
 * Account menu dropdown header: title, VIP/tier badge, and expandable contract/membership list.
 * Badge is interactive when there is at least one contract; expanding shows the list.
 * The selectOwnerIdLabel is shown only when there are multiple memberships.
 */
export const MkAccountMenuHeader: React.FC<MkAccountMenuHeaderProps> = ({ className, title, subtitle, selectOwnerIdLabel, contractDetails }) => {
  const { themeBrand: brand } = useSiteContext()
  return (
    <div className={clsx('account-menu__dropdown__header', className)}>
      <h6 className={clsx('account-menu__dropdown__header__title subtitle-2')}>{title}</h6>
      <MembershipSwitcherDropdown
        badgeClassName={clsx('account-menu__dropdown__header__badge')}
        contractDetails={contractDetails}
        label={subtitle}
        invert={brand === 'sir'}
        selectOwnerIdLabel={selectOwnerIdLabel}
      />
    </div>
  )
}
